var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 824.03,
    height: 67.05,
    viewBox: "0 0 824.03 67.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#2684ff;}.cls-3{fill:#0052cc;}.cls-4{fill:#253858;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 28.54,
    y1: 35.57,
    x2: 11.4,
    y2: 65.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2684ff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Atlassian Access-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Live_type",
    "data-name": "Live type"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.64,30.56a1.88,1.88,0,0,0-3.2.35L.21,63.36a1.94,1.94,0,0,0,1.73,2.81h22.6a1.88,1.88,0,0,0,1.74-1.07C31.15,55,28.2,39.7,19.64,30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.55,1a42.79,42.79,0,0,0-2.5,42.26L39.94,65.1a2,2,0,0,0,1.74,1.07h22.6A1.94,1.94,0,0,0,66,63.36L34.85,1A1.83,1.83,0,0,0,31.55,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296.63,27.06c0,8,3.73,14.42,18.31,17.24,8.7,1.82,10.52,3.23,10.52,6.13s-1.82,4.64-7.95,4.64a44.81,44.81,0,0,1-21.13-5.72V62.44c4.39,2.16,10.19,4.56,21,4.56,15.25,0,21.3-6.79,21.3-16.9m0,0c0-9.53-5.06-14-19.31-17.07-7.87-1.74-9.77-3.48-9.77-6,0-3.15,2.81-4.47,8-4.47,6.3,0,12.51,1.9,18.4,4.56V14.63a41.64,41.64,0,0,0-18-3.73c-14.09,0-21.38,6.14-21.38,16.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "492.5 11.73 492.5 66.17 504.1 66.17 504.1 24.66 508.99 35.68 525.39 66.17 539.98 66.17 539.98 11.73 528.38 11.73 528.38 46.87 523.98 36.67 510.81 11.73 492.5 11.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 406.04,
    y: 11.73,
    width: 12.68,
    height: 54.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.41,50.1c0-9.53-5.05-14-19.3-17.07-7.87-1.74-9.78-3.48-9.78-6,0-3.15,2.82-4.47,8-4.47,6.29,0,12.51,1.9,18.39,4.56V14.63a41.57,41.57,0,0,0-18-3.73C356.7,10.9,349.4,17,349.4,27.06c0,8,3.73,14.42,18.32,17.24,8.7,1.82,10.52,3.23,10.52,6.13s-1.82,4.64-8,4.64a44.8,44.8,0,0,1-21.12-5.72V62.44c4.39,2.16,10.19,4.56,21,4.56,15.24,0,21.29-6.79,21.29-16.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "198.15 11.73 198.15 66.17 224.21 66.17 228.31 54.41 210.91 54.41 210.91 11.73 198.15 11.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.67 11.73 146.67 23.5 160.75 23.5 160.75 66.17 173.51 66.17 173.51 23.5 188.59 23.5 188.59 11.73 146.67 11.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.16,11.73H111.44l-19,54.44H107L109.65,57A36,36,0,0,0,130,57l2.7,9.17h14.5ZM119.8,47.19a24.67,24.67,0,0,1-7-1l7-23.77,7,23.77A24.69,24.69,0,0,1,119.8,47.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.13,11.73H252.4l-19,54.44h14.5L250.61,57a36,36,0,0,0,20.31,0l2.69,9.17h14.5Zm-8.36,35.46a24.69,24.69,0,0,1-7-1l7-23.77,7,23.77A24.67,24.67,0,0,1,260.77,47.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M464.4,11.73H447.68l-19,54.44h14.5L445.89,57a36,36,0,0,0,20.3,0l2.69,9.17h14.5ZM456,47.19a24.79,24.79,0,0,1-7-1l7-23.77,7,23.77A24.79,24.79,0,0,1,456,47.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M579.16,53l-4.89,13.17h-9L588.33,7.68h10.15l23,58.48h-9L607.65,52.9a70.76,70.76,0,0,1-14.51,1.6A72,72,0,0,1,579.16,53Zm26.08-6.77-11.84-32L581.57,46.31a71,71,0,0,0,11.57,1.07A78,78,0,0,0,605.24,46.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M658.3,65c-2.67,1.42-6.77,2-10.86,2-15.85,0-23.24-9.61-23.24-23.23,0-13.44,7.39-23.06,23.24-23.06A23.56,23.56,0,0,1,658,22.9V30A22.53,22.53,0,0,0,648,27.88c-11.57,0-16.29,7.3-16.29,15.94s4.81,15.93,16.47,15.93a28.12,28.12,0,0,0,10.15-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M698.44,65c-2.67,1.42-6.77,2-10.86,2-15.85,0-23.24-9.61-23.24-23.23,0-13.44,7.39-23.06,23.24-23.06a23.56,23.56,0,0,1,10.59,2.14V30a22.49,22.49,0,0,0-10.06-2.14c-11.57,0-16.29,7.3-16.29,15.94s4.81,15.93,16.47,15.93a28.12,28.12,0,0,0,10.15-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M728.44,67.05c-16.65,0-24-9.61-24-23.23,0-13.44,7.48-23.06,21-23.06,13.71,0,19.23,9.53,19.23,23.06v3.47h-32.5c1.07,7.57,6,12.46,16.47,12.46a39.48,39.48,0,0,0,13.53-2.4v7C738.58,66.34,733,67.05,728.44,67.05ZM712.15,40.7H737c-.44-8.28-4.18-13-11.84-13C717,27.71,713,33,712.15,40.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M767.78,67.05a34.28,34.28,0,0,1-15.49-3.29v-8.1A34.84,34.84,0,0,0,768.13,60c5.88,0,8.91-2.4,8.91-5.88s-2.59-5.34-11-7.38c-9.88-2.41-14.07-6.23-14.07-13.54,0-7.74,6-12.46,16.11-12.46A31.65,31.65,0,0,1,782.38,24v7.92c-5.34-2.67-9.71-4.1-14.42-4.1-5.61,0-8.64,2-8.64,5.43,0,3.12,2.14,5.08,10.33,7,9.88,2.4,14.86,6.05,14.86,13.8C784.51,61.44,779.71,67.05,767.78,67.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M807.3,67.05a34.28,34.28,0,0,1-15.49-3.29v-8.1A34.87,34.87,0,0,0,807.65,60c5.88,0,8.91-2.4,8.91-5.88s-2.59-5.34-11-7.38c-9.88-2.41-14.07-6.23-14.07-13.54,0-7.74,6-12.46,16.12-12.46A31.64,31.64,0,0,1,821.9,24v7.92c-5.34-2.67-9.71-4.1-14.42-4.1-5.61,0-8.64,2-8.64,5.43,0,3.12,2.14,5.08,10.33,7,9.88,2.4,14.86,6.05,14.86,13.8C824,61.44,819.23,67.05,807.3,67.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAccess);
export default __webpack_public_path__ + "static/media/logo-access.335d029d6f024b6d27ad0ada5cc37a3e.svg";
export { ForwardRef as ReactComponent };